module.exports = __webpack_public_path__ + "historico.png?2923c2c4c9de1b3577db639a217304a4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty/historico.png
// module id = 430
// module chunks = 0